import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import AppContainer from "../Structure/AppContainer";
import AuthContext from "../../Context/AuthContext";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxSupplierInvoices from "../../util/remote/ajaxSupplierInvoices";
import SupplierInvoiceDetailsModal from "./SupplierInvoiceDetailsModal";
import Loader from "../Common/Loader";
const ViewSupplierInvoicesToSet4Payments = () => {
  const { userId } = useContext(AuthContext);
  const navigate = useNavigate();
  // State
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [view_details, setView_details] = useStateCallback(false);
  // Fetch invoices with balance > 0
  const fetchSupplierInvoices = async () => {
    setLoading(true);
    setInvoices([]);
    const server_response =
      await ajaxSupplierInvoices.fetchSupplierInvoicesReadyto_be_paid({});
    setLoading(false);
    if (server_response.status === "OK") {
      // Filter invoices with balance > 0
      const pendingInvoices = server_response.details.filter(
        (inv) => parseFloat(inv.balance) > 0
      );
      setInvoices(pendingInvoices);
    } else {
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchSupplierInvoices();
  }, []);
  // Modal handler
  const handleView_details = (invoiceId) => {
    setView_details(false, () =>
      setView_details(<SupplierInvoiceDetailsModal invoiceId={invoiceId} />)
    );
  };
  const handleView_set_for_payments = async (invoiceId) => {
    const confirmAction = window.confirm(
      "Are you sure you want to set this invoice for payments?"
    );
    if (!confirmAction) return;
    setLoading(true);
    var data = { invoID: invoiceId };
    const response = await ajaxSupplierInvoices.setInvoiceForPayment(data);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      // Refresh invoices
      fetchSupplierInvoices();
    } else {
      toast.error(response.message);
    }
  };
  return (
    <AppContainer title="Invoices ready for payments">
      <div className="container-fluid">
        <Toaster />
        {loading && <Loader />}
        {view_details}
        {/* Table */}
        <div className="card shadow-sm border-0">
          <div className="card-header bg-light fw-bold">
            <i className="fa fa-list me-2"></i> Organisation Supplier Invoices
            Ready for payments
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Invoice No</th>
                    <th>Delivery Reff</th>
                    <th>Supplier</th>
                    <th>Contact</th>
                    <th>Amount</th>
                    <th>Balance</th>
                    <th>Date</th>
                    <th>Created By</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(invoices) && invoices.length > 0 ? (
                    invoices.map((inv, key) => (
                      <tr key={inv.id}>
                        <td>{key + 1}</td>
                        <td>{inv.invoice_no}</td>
                        <td>{inv.delievery_reff_no}</td>
                        <td>{inv.buss_name}</td>
                        <td>{inv.buss_contact}</td>
                        <td>{parseFloat(inv.amount).toLocaleString()}</td>
                        <td>
                          <span className="badge bg-warning text-dark">
                            {parseFloat(inv.balance).toLocaleString()}
                          </span>
                        </td>
                        <td>{inv.date_created}</td>
                        <td>{inv.created_by}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm btn-outline-info"
                            style={{ margin: "2px" }}
                            onClick={() => handleView_set_for_payments(inv.id)}
                          >
                            <i className="fa fa-eye "></i>set_4_payments
                          </button>{" "}
                          <br />
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => handleView_details(inv.id)}
                          >
                            <i className="fa fa-eye "></i>details
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center py-3">
                        {loading
                          ? "Loading invoices..."
                          : "No pending invoices found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default ViewSupplierInvoicesToSet4Payments;
